/**
 * @generated SignedSource<<18ba95d186b5e0fff3c62950e200c50b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ProfileSettings_notificationCycles",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileSettingsForm_notificationCycles"
    }
  ],
  "type": "NotificationCycle",
  "abstractKey": null
};

node.hash = "2238069c4e6d84ed29527c24859101c6";

module.exports = node;
